export const openModal = (id: string) => {
  const modal = document.getElementById(id)
  if (modal !== null) {
    modal.classList.remove('modal-hidden')
  } else {
    console.error('Modal element not found.')
  }
}
export const closeModal = (id: string) => {
  const modal = document.getElementById(id)
  if (modal !== null) {
    try {
      modal.classList.add('modal-hidden')
    } catch (error) {
      console.log(error)
    }
  } else {
    console.error('Modal element not found.')
  }
}
